import type { QueryClient } from '@tanstack/react-query';

import { meAccessQueryOptions } from './queryOptions';

export const bootAccessLoader = (queryClient: QueryClient) => async (): Promise<null> => {
  if (!localStorage.getItem('userId')) return null;
  void queryClient.prefetchQuery(meAccessQueryOptions());
  return null;
};
